export default {
  path: 'suppliers',
  component: () => import('@/views/business/inventory/suppliers/index.vue'),
  children: [
    {
      path: ':supplierId/details',
      name: 'inventory.suppliers.details',
      component: () => import('@/views/business/inventory/suppliers/details.vue'),
      meta: {
        hideTabs: true,
      },
    },
    {
      path: 'create',
      name: 'inventory.suppliers.create',
      component: () => import('@/views/business/inventory/suppliers/details.vue'),
      meta: {
        hideTabs: true,
      },
    },
    {
      path: '',
      name: 'inventory.suppliers.list',
      component: () => import('@/views/business/inventory/suppliers/list.vue'),
    },
  ],
}
